export const LIQUIDATE_DATA_ABI = ['uint256', 'uint256', 'uint256', 'int256', 'uint256', 'bool']
